<div class="page-body">
  <div class="contents-wrapper">
    <div class="contents-container">
      <h1 class="heading">Monatsrechnung</h1>
      <div class="text">
        Ihr Einkauf wird auf der nächsten Zaver-Monatsrechnung bei {{ merchantName }} erscheinen.
      </div>

      <ng-container *ngIf="totalCheckoutValue">
        <div class="checkout-details">
          <hr class="details-divider" />
          <div class="checkout-item">
            <p>Gesamtbetrag</p>
            <p>{{ totalCheckoutValue | value }}</p>
          </div>
          <hr class="details-divider" />
        </div>
      </ng-container>

      <div class="footer-wrapper">
        <div class="footer-container">
          <div class="button-wrapper">
            <zaver-primary-button
              (click)="handleCtaClick()"
              [text]="'Kauf abschließen'"
              [disabled]="navigationInProgress"
            ></zaver-primary-button>
          </div>

          <div class="details-link">
            <zaver-button-link
              text="Details anzeigen"
              (click)="toggleModal(0)"
            ></zaver-button-link>
          </div>

          <p class="sub-info-text">
            Indem Sie Kauf abschließen klicken, stimmen Sie den
            <zaver-button-link
              [text]="
                state.checkoutCustomizations.merchantTermsUrlText || 'AGB'
              "
              (click)="toggleModal(selectorItems?.length > 1 ? 1 : 0)"
            ></zaver-button-link>
            von {{ merchantName }} zu.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<zaver-checkout-modal
  *ngIf="modalActive"
  [buttonText]="'Schließen'"
  [logo]="'assets/img/Zaver_Logotype_Circle_Coal_DE.svg'"
  (onClose)="deactivateModal()"
>
  <app-selector
    #selector
    *ngIf="!!selectorItems"
    [selectorItems]="selectorItems"
    [selectedItem]="selectedItem"
  ></app-selector>
</zaver-checkout-modal>
